<div class="scad-drag-area__side-section">
  <div class="scad-drag-sidemenu">

    <div *ngIf="lastSelectedNodeType===nodeTypes?.source">
      <div class="scad-title__semi-bold mb-4">Source</div>
      <div class="scad-title__sm-label">Connect a file or database</div>
      <div class="mt-3">
        <span class='clickUpload btn' (click)="file.click()">
          <input type='file' #file (change)="onFileChange($event.target,'click')" >
          <span>{{_flowBuilder?.activeNode?.sourceFile?_flowBuilder?.activeNode?.sourceFile:'Select a File'}}</span>
        </span>
      </div>
    </div>


    <div *ngIf="lastSelectedNodeType===nodeTypes?.target">
      <div class="scad-title__semi-bold mb-4">Destination aaa</div>
      <div class="scad-title__sm-label">You can choose to unload your data into a connector or export the dataset directly.</div>
      <div class="mt-3">
        <span class='clickUpload btn' (click)="file.click()">
          <input type='file' #file (change)="onFileChange($event.target,'click')" >
          <span>{{'Publiscad Data'}}</span>
        </span>
      </div>

    </div>
  </div>
</div>

